(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsell);
  } else {
    initUpsell();
  }
  
  function initUpsell() {
    var upsell = document.querySelector('.mh-upsell');
    if (!upsell) return;

    var form = upsell.querySelector('.mh-upsell-form');
    var selectedProduct = null;

    // Handle radio button selection
    form.addEventListener('change', function(e) {
      e.stopPropagation();
      if (e.target.type === 'radio') {
        // Remove selected class from all options
        var allOptions = upsell.querySelectorAll('.mh-product-option');
        allOptions.forEach(function(option) {
          option.classList.remove('selected');
        });
        
        // Add selected class to current option
        var selectedOption = e.target.closest('.mh-product-option');
        if (selectedOption) {
          selectedOption.classList.add('selected');
        }
        
        // Store selected product
        selectedProduct = {
          variantId: e.target.value,
          productId: e.target.getAttribute('data-product-id'),
          productTitle: e.target.getAttribute('data-product-title')
        };
      }
    });

    // Handle clicking on product option (not just radio button)
    var productOptions = upsell.querySelectorAll('.mh-product-option');
    productOptions.forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Don't trigger if clicking on the radio button itself
        if (e.target.type === 'radio') return;
        
        var radio = option.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    /**
     * ===== Belangrijkste wijziging =====
     * We intercepten fetch naar /cart/add(.js) en voegen de upsell
     * in dezelfde request-body toe (JSON of FormData).
     */
    var originalFetch = window.fetch;
    var upsellInjectedOnce = false; // per request guard

    function ensureItemsArray(obj) {
      // Converteer {id, quantity, properties} naar {items:[...]} òf voeg items toe
      var items = [];
      if (Array.isArray(obj.items)) {
        items = obj.items.slice();
      } else if (obj.id) {
        items.push({
          id: String(obj.id),
          quantity: obj.quantity ? Number(obj.quantity) : 1,
          properties: obj.properties || undefined
        });
        // Ruim enkelvoudige velden op, om dubbele add te voorkomen
        delete obj.id;
        delete obj.quantity;
        delete obj.properties;
      }
      obj.items = items;
      return obj;
    }

    function formDataHasItemsKeys(fd) {
      var has = false;
      fd.forEach(function(_, key) {
        if (/^items\[\d+\]\[id\]$/.test(key)) has = true;
      });
      return has;
    }

    function getNextItemsIndex(fd) {
      var maxIdx = -1;
      fd.forEach(function(_, key) {
        var m = key.match(/^items\[(\d+)\]\[id\]$/);
        if (m) {
          var idx = parseInt(m[1], 10);
          if (idx > maxIdx) maxIdx = idx;
        }
      });
      return maxIdx + 1;
    }

    window.fetch = function(input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var isCartAdd = typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'));
        var method = (init && (init.method || init.type)) || (input && input.method) || 'GET';

        // Alleen ingrijpen bij POST naar /cart/add en als er een upsell is gekozen
        if (isCartAdd && method.toUpperCase() === 'POST' && selectedProduct && !upsellInjectedOnce) {
          upsellInjectedOnce = true; // guard tegen dubbele injectie in dezelfde flow

          // Clone init zó dat we de body kunnen aanpassen
          var newInit = init ? Object.assign({}, init) : {};
          var headers = newInit.headers || {};
          // Headers kunnen verschillende vormen hebben; maak het makkelijk leesbaar
          var contentType = '';
          if (headers && typeof headers.get === 'function') {
            contentType = headers.get('Content-Type') || headers.get('content-type') || '';
          } else if (typeof headers === 'object') {
            contentType = headers['Content-Type'] || headers['content-type'] || '';
          }

          // JSON request body
          if (contentType && contentType.indexOf('application/json') > -1 && newInit.body && typeof newInit.body === 'string') {
            try {
              var payload = JSON.parse(newInit.body);
              payload = ensureItemsArray(payload);

              // Check of upsell niet al in items zit
              var already = payload.items.some(function(it) { return String(it.id) === String(selectedProduct.variantId); });
              if (!already) {
                payload.items.push({ id: String(selectedProduct.variantId), quantity: 1 });
              }

              newInit.body = JSON.stringify(payload);
            } catch (e) {
              // Als parsen mislukt, laten we de body ongemoeid en doen we niets extra's
            }
          }
          // FormData body
          else if (newInit.body && typeof FormData !== 'undefined' && newInit.body instanceof FormData) {
            try {
              var fd = newInit.body;

              if (formDataHasItemsKeys(fd)) {
                // Er is al items[...] aanwezig -> voeg upsell toe met volgende index
                var idx = getNextItemsIndex(fd);
                fd.append('items[' + idx + '][id]', String(selectedProduct.variantId));
                fd.append('items[' + idx + '][quantity]', '1');
              } else {
                // Geen items[...] gevonden. Laat de originele velden met rust (om theme-compat te houden)
                // en append alléén een extra items[1] zodat Shopify beide kan lezen als het thema dat ondersteunt.
                // (Dit is de meest veilige fallback zonder het gehele formulier te herschrijven.)
                var nextIdx = 1;
                // Indien het formulier al items[0] gebruikt voor id/qty in een andere notatie, probeer index 0 te reserveren.
                // We checken een simpele 'id' field; als die bestaat, nemen we index 1 voor upsell.
                fd.append('items[' + nextIdx + '][id]', String(selectedProduct.variantId));
                fd.append('items[' + nextIdx + '][quantity]', '1');
              }
            } catch (e) {
              // Laat als fallback de originele request ongemoeid
            }
          }
          // Andere content-types (x-www-form-urlencoded of onbekend)
          else if (contentType && contentType.indexOf('application/x-www-form-urlencoded') > -1 && typeof newInit.body === 'string') {
            try {
              var params = new URLSearchParams(newInit.body);
              // Voeg een items[1] toe als fallback
              params.append('items[1][id]', String(selectedProduct.variantId));
              params.append('items[1][quantity]', '1');
              newInit.body = params.toString();
            } catch (e) {
              // Laat ongemoeid bij fout
            }
          }

          // Stuur de (mogelijk) gemodificeerde request door
          return originalFetch.call(this, input, newInit).finally(function() {
            // reset voor een volgende add
            upsellInjectedOnce = false;
          });
        }
      } catch (err) {
        // Als er iets misgaat in de intercept, val terug op normale fetch
      }
      return originalFetch.apply(this, arguments);
    };

    // Override ProductForm class for MommysHomes theme (alleen voor status/compat; de echte bundeling gebeurt in fetch intercept)
    function overrideProductFormClass() {
      try {
        if (typeof customElements !== 'undefined' && customElements.get('product-form')) {
          var ProductForm = customElements.get('product-form');
          var originalOnSubmitHandler = ProductForm.prototype.onSubmitHandler;
          
          ProductForm.prototype.onSubmitHandler = function(evt) {
            if (originalOnSubmitHandler) {
              originalOnSubmitHandler.call(this, evt);
            }
          };
        } else {
          setTimeout(overrideProductFormClass, 100);
        }
      } catch (e) {
        // stil falen voor compat
      }
    }
    setTimeout(overrideProductFormClass, 200);
  }
})();

